import { render, staticRenderFns } from "./NegotiationList.vue?vue&type=template&id=a623a826&scoped=true&"
import script from "./NegotiationList.vue?vue&type=script&lang=js&"
export * from "./NegotiationList.vue?vue&type=script&lang=js&"
import style0 from "./NegotiationList.vue?vue&type=style&index=0&id=a623a826&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a623a826",
  null
  
)

export default component.exports